import React from "react";
import { ModalComponent } from "../../../components/Modal.components";
import { PageTitle } from "../../../components/style";
import { Boxed } from "../../../components/Boxed.components";
import { Button } from "../../../components/Button.components";
import { Text } from "../../../components/Text.components";
export const DeleteRequestForm = (props) => {
  console.log(props);
  // State props
  const { deleteRequestModal, singleRequestData } = props;
  // Dispatch props
  const { closeModal, deleteRequestForm } = props;

  return (
    <ModalComponent
      show={deleteRequestModal}
      onHide={closeModal}
      title={<PageTitle margin="5px 0">Delete Request Form</PageTitle>}
      footer={
        <Boxed display="flex" width="100%">
          <Button clear onClick={closeModal}>
            Cancel
          </Button>
          <Button
            margin="0 0 0 auto"
            color='#FF0000'
            onClick={() => deleteRequestForm(singleRequestData._id)}
          >
            Confirm
          </Button>
        </Boxed>
      }
    >
      <Boxed>
        <Text>
          Are you sure you want to delete this request form? <br /> Please note that you
          can’t undo this process.
        </Text>
      </Boxed>
    </ModalComponent>
  );
};
